import { render, staticRenderFns } from "./TwoFactorTimer.vue?vue&type=template&id=2b1162ee"
import script from "./TwoFactorTimer.vue?vue&type=script&lang=js"
export * from "./TwoFactorTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports